import React from 'react';
import hmacSHA256 from 'crypto-js/hmac-sha256';
import Base64 from 'crypto-js/enc-base64';

function SecureKey() {
  const SECRET_KEY = 'APFTE&*&%^$#M'; // Keep this secret!

  const generateSignature = (dataObject) => {
    const message = JSON.stringify(dataObject);
    const hash = hmacSHA256(message, SECRET_KEY);
    return Base64.stringify(hash);
  };

  const verifySignature = (dataObject, signature) => {
    const message = JSON.stringify(dataObject);
    const hash = hmacSHA256(message, SECRET_KEY);
    const expectedSignature = Base64.stringify(hash);
    return expectedSignature === signature;
  };

  return { generateSignature, verifySignature };
}

export default SecureKey;
